import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_EP_TICKET } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIdEpTicketState extends EntityState<IID_EP_TICKET, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_EP_TICKET })
@InterfaceDataStore(InterfaceName.EP_TICKET)
export class IIDepTicketStore extends EntityStore<IIdEpTicketState> {
  constructor() {
    super([]);
  }
}
